export const recentUsersParser = data =>
  data.map(item => ({
    id: item.userId,
    name: `${item.firstName} ${item.name}`,
    position: item.jobTitle,
  }));
